
import type { Calculate } from '@/models/billing'

export interface ProductsState {
  products: []
  calculate: Calculate | ''
  getPaymentLink: string
}

export const initialState: ProductsState = {
  products: [],
  calculate: '',
  getPaymentLink: '',
}
